import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import User from '_class/User';
import { addError } from 'actions/index';
import { getSchoolByGroupGraphId, getEducationGroups } from 'actions/sections';
import { getSchoolDataForSections } from 'actions/schools';
import { searchSectionByTitle } from 'actions/search';
import { PRESCHOOL } from 'constants/schoolTypes';
import schoolHandling from 'helpers/schoolHandling';
import api from 'lib/api';
import Select from 'react-select';
import { Spinner } from 'UI';
import Onboarding from 'containers/Onboarding/Onboarding';
import CourseSelectList from 'components/List/CourseSelect';
import { QuillEditor } from 'UI/Inputs';
import { Button, Radio, translate } from '@haldor/ui';
import { getActiveSchool } from 'helpers/localstorage';

var SectionForm = /*#__PURE__*/function (_Component) {
  _inherits(SectionForm, _Component);

  var _super = _createSuper(SectionForm);

  function SectionForm(props) {
    var _props$schoolData;

    var _this;

    _classCallCheck(this, SectionForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      var _this$props = _this.props,
          editView = _this$props.editView,
          connectView = _this$props.connectView,
          teamsContext = _this$props.teamsContext;

      if (editView || connectView) {
        _this.loadEditView();
      }

      if (teamsContext != null) {
        _this.setSectionFieldToTeam();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.schoolData == null) {
        var activeSchool = getActiveSchool(_this.props.currentUser.id);

        _this.props.getSchoolDataForSections(activeSchool).then(function () {
          var _this$props$schoolDat;

          var values = _this.state.values;
          values.type = (_this$props$schoolDat = _this.props.schoolData) !== null && _this$props$schoolDat !== void 0 && _this$props$schoolDat.allowManualEducationGroupConnection ? 'EDUCATION_GROUP' : 'MENTOR_GROUP';

          _this.setState({
            values: values,
            loading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setSectionFieldToTeam", function () {
      var sectionInput = {
        label: _this.props.teamsContext.team.displayName,
        value: _this.props.teamsContext.team.groupId
      };

      _this.setState({
        sectionInput: sectionInput,
        disableSectionInput: true
      });

      _this.props.getSchoolByGroupGraphId(sectionInput.value).then(function () {
        if (_this.props.graphGroupSchool != null) {
          var values = _this.state.values;
          values.schoolId = _this.props.graphGroupSchool.id;

          _this.setState({
            values: values
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loadEditView", function () {
      var selectedCourse = null;
      var values = _this.state.values;
      var extraCourses = [];
      values.title = _this.props.section.title;
      values.description = _this.props.section.description;

      if (!_this.props.connectView) {
        values.type = _this.props.section.type;
      }

      if (_this.props.section.courses.length > 0) {
        _this.props.section.courses.forEach(function (extraCourse) {
          if (_this.props.section.courseID != extraCourse.id) {
            var schoolType = _this.props.translate(extraCourse.typeOfSchooling);

            extraCourses.push({
              id: extraCourse.id,
              title: "".concat(extraCourse.title, " ").concat(extraCourse.year != null ? extraCourse.year : '', " (").concat(schoolType, ")"),
              colorCode: extraCourse.colorCode
            });
          } else {
            selectedCourse = extraCourse;
          }
        });
      }

      _this.setState({
        values: values,
        extraCoursesInput: extraCourses,
        selectedCourse: selectedCourse
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (input, event) {
      var values = _this.state.values;
      values[input] = event.target.value;

      _this.setState({
        values: values
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (event) {
      var values = _this.state.values;
      values.id = _this.props.section.id;
      var extraCourses = [];

      if (_this.state.values.type == 'EDUCATION_GROUP') {
        if (_this.state.extraCoursesInput != null && _this.state.extraCoursesInput.length > 0) {
          _this.state.extraCoursesInput.forEach(function (extraCourse) {
            var duplicated = extraCourses.find(function (dupe) {
              return dupe.id == extraCourse.id;
            });

            if (duplicated == null) {
              extraCourses.push(extraCourse);
            }
          });
        }
      }

      values.courses = extraCourses;

      _this.setState({
        values: values
      }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var newError, that, _translate, user, schoolTitle, result;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newError = _this.validateForm();

                if (newError) {
                  _context.next = 16;
                  break;
                }

                that = _assertThisInitialized(_this);
                _context.next = 5;
                return _this.setState({
                  isSending: true
                });

              case 5:
                if (!_this.props.connectView) {
                  _context.next = 15;
                  break;
                }

                _translate = _this.props.translate;
                user = new User(_this.props.currentUser);
                schoolTitle = user.getActiveSchool().title;
                _context.next = 11;
                return swal.fire({
                  title: _this.props.translate('are-you-sure'),
                  html: "\n\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t<li>".concat(_translate('It´s important that you connect the group to the correct school.'), "</li>\n\t\t\t\t\t\t\t<li>").concat(_translate('When the group has been linked you will not be able to change group type by yourself.'), "</li>\n\t\t\t\t\t\t\t<li>").concat(_translate('Information about who and when the group was linked is saved.'), "</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t<br />\n\t\t\t\t\t\t").concat(_translate('Do you want to connect <strong>{{group_name}}</strong> as a <strong>{{group_type}}</strong> to <strong>{{school_name}}</strong>?', values.title, _translate(values.type), schoolTitle), "\n\t\t\t\t\t\t<br />\n\t\t\t\t\t\t"),
                  showCancelButton: true,
                  focusConfirm: false,
                  cancelButtonText: _this.props.translate('No'),
                  confirmButtonText: _this.props.translate('Yes')
                });

              case 11:
                result = _context.sent;

                if (!(result.dismiss != null)) {
                  _context.next = 15;
                  break;
                }

                _this.setState({
                  isSending: false
                });

                return _context.abrupt("return", true);

              case 15:
                if (_this.props.editView) {
                  api.put('sections', values).then(function () {
                    _this.props.addError(_this.props.translate('changes-saved'), 'info');

                    _this.props.onAbort(true, true);
                  });
                } else {
                  api.post('sections', values).then(function (response) {
                    _this.props.getEducationGroups();

                    if (values.schoolId != 0) {
                      schoolHandling.setSchoolOnUser(_this.props.currentUser, values.schoolId);
                    }

                    if (that.props.activeTab == null) {
                      _this.props.history.push("/groups/".concat(response.data));
                    } else {
                      that.props.teamsTabCloseForm();
                    }
                  });
                }

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "validateForm", function () {
      var values = _this.state.values;
      var newError = false;

      if (values.title.length === 0) {
        newError = true;

        _this.props.addError(_this.props.translate('enter-a-title-error'), 'notice');
      }

      if (_this.props.editView == false) {
        if (values.graphId == null) {
          newError = true;

          _this.props.addError(_this.props.translate('pick-a-section'), 'notice');
        }
      }

      return newError;
    });

    _defineProperty(_assertThisInitialized(_this), "onDescriptionChange", function (text) {
      var values = _this.state.values;
      values.description = text;

      _this.setState({
        values: values
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClickSave", function (event) {
      event.preventDefault();

      if (!_this.state.isSending) {
        _this.onSubmit();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCoursesChange", function (courses) {
      // courses = array with course objects
      // id, title
      _this.setState({
        extraCoursesInput: courses
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchSection", function (title, callback) {
      if (!title) {
        callback([]);
      } else {
        var searchValue = title.trim();
        searchValue = searchValue.replace(/[^A-Za-z0-9åäöÅÄÖ ]/g, "");
        searchValue = encodeURIComponent(searchValue);

        if (searchValue != null && searchValue != "") {
          if (searchValue.length < 3) {
            callback([]);
            return false;
          }

          _this.props.searchSectionByTitle(searchValue, true, function (data) {
            var options = [];
            data.forEach(function (section) {
              options.push({
                value: section.graphId,
                label: section.title
              });
            });
            callback(options);
          });
        } else {
          callback([]);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "exitOnboarding", function () {
      return _this.setState({
        onboarding: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectSchool", function (option) {
      var values = _this.state.values;
      values.schoolId = option.values;

      _this.setState({
        values: values
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onTypeChange", function (value) {
      var values = _this.state.values;
      values.type = value;

      _this.setState({
        values: values
      });
    });

    var onboarding = false;

    if (props.onboarding) {
      onboarding = props.onboarding;
    }

    var schoolId = 0;
    var _title = '';
    var description = '';
    var graphId = null;

    var _user = new User(props.currentUser);

    if (props.connectView) {
      schoolId = _user.getActiveSchool().id;
      _title = props.section.title;
      graphId = props.section.graphId;

      if (props.section.description != null) {
        description = props.section.description;
      }
    }

    _this.state = {
      values: {
        id: 0,
        title: _title,
        description: description,
        graphId: graphId,
        course: null,
        schoolId: schoolId,
        extraCourses: [],
        teamsUrl: null,
        type: (_props$schoolData = props.schoolData) !== null && _props$schoolData !== void 0 && _props$schoolData.allowManualEducationGroupConnection && (_user.isTeacher() || _user.isAdministrator()) ? 'EDUCATION_GROUP' : 'MENTOR_GROUP'
      },
      extraCoursesInput: [],
      isSending: false,
      disableSectionInput: false,
      loadingSchedules: false,
      selectedCourse: null,
      onboarding: onboarding,
      loading: props.schoolData == null,
      steps: [{
        target: '#school-input',
        content: props.translate('groupconfig-explain-school'),
        disableBeacon: true
      }, {
        target: '#course-input',
        content: props.translate('groupconfig-explain-courses'),
        disableBeacon: true
      }, {
        target: '#teams-header-actions',
        content: props.translate('groupconfig-explain-cog'),
        disableBeacon: true
      }]
    };
    return _this;
  }

  _createClass(SectionForm, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props$schoolDat2,
          _this$props$schoolDat3;

      var preschool = this.props.currentUser.schools.getActiveSchool(this.props.currentUser.userId).type == PRESCHOOL;
      var disabled = false;
      var schoolOptions = [];
      var user = new User(this.props.currentUser);

      if (this.props.currentUser != null && this.props.currentUser.schools != null) {
        this.props.currentUser.schools.forEach(function (school) {
          schoolOptions.push({
            label: school.title,
            value: school.id
          });
        });
      }

      var schoolValue = schoolOptions.find(function (school) {
        return school.value == _this2.state.values.schoolId;
      });

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", {
          className: "form-container form-create-section"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: this.props.teamsContext != null ? 'form-container no-section-found-create-section' : 'form-container form-create-section'
      }, this.state.onboarding ? /*#__PURE__*/React.createElement(Onboarding, {
        steps: this.state.steps,
        onExit: this.exitOnboarding,
        onboarding: this.state.onboarding
      }) : null, this.props.teamsContext != null ? /*#__PURE__*/React.createElement("div", null, this.props.translate('form-no-section-found')) : null, this.state.isSending ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }), /*#__PURE__*/React.createElement("br", null), this.props.editView ? this.props.translate('creation-phrase-1') : this.props.translate('creating-section'), "...")) : null, /*#__PURE__*/React.createElement("form", {
        className: "form form-component"
      }, this.props.connectView ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "color--blue"
      }, this.state.values.title + ' ' + this.props.translate('to').toLowerCase() + ' ' + user.getActiveSchool().title)) : null, this.props.connectView ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Select group type')), (user.isTeacher() || user.isAdministrator()) && ((_this$props$schoolDat2 = this.props.schoolData) === null || _this$props$schoolDat2 === void 0 ? void 0 : _this$props$schoolDat2.allowManualEducationGroupConnection) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Radio, {
        input: {
          onChange: this.onTypeChange,
          value: this.state.values.type
        },
        optionValue: "EDUCATION_GROUP",
        label: this.props.translate('EDUCATION_GROUP')
      })), (user.isMentor() || user.isAdministrator()) && (_this$props$schoolDat3 = this.props.schoolData) !== null && _this$props$schoolDat3 !== void 0 && _this$props$schoolDat3.allowManualMentorGroupConnection ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.35rem'
        }
      }, /*#__PURE__*/React.createElement(Radio, {
        input: {
          onChange: this.onTypeChange,
          value: this.state.values.type
        },
        optionValue: "MENTOR_GROUP",
        label: this.props.translate('MENTOR_GROUP')
      })) : null) : null, this.props.teamsContext != null && !this.props.editView && !this.props.connectView && this.props.currentUser.schools.length > 1 ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('school')), /*#__PURE__*/React.createElement("div", {
        id: "school-input"
      }, /*#__PURE__*/React.createElement(Select, {
        dataType: "schools",
        placeholder: this.props.translate('pick-a-school'),
        disabled: this.props.graphGroupSchool != null,
        value: schoolValue,
        options: schoolOptions,
        onChange: this.selectSchool
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(QuillEditor, {
        placeholder: this.props.translate('describe-the-group'),
        label: this.props.translate('description'),
        onChange: this.onDescriptionChange,
        text: this.state.values.description
      })), !preschool && this.state.values.type == 'EDUCATION_GROUP' ? /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        id: "course-input"
      }, /*#__PURE__*/React.createElement(CourseSelectList, {
        section: this.props.section,
        onChange: this.onCoursesChange
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, this.props.connectView ? /*#__PURE__*/React.createElement(Button, {
        onClick: this.onClickSave,
        id: "save-input",
        disabled: disabled
      }, this.props.translate('Connect to {{school_name}}', user.getActiveSchool().title)) : /*#__PURE__*/React.createElement(Button, {
        onClick: this.onClickSave,
        id: "save-input",
        disabled: disabled
      }, this.props.editView ? this.props.translate('save') : this.props.translate('publish')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick(event) {
          event.preventDefault();

          _this2.props.onAbort(false);
        },
        type: "secondary"
      }, this.props.translate('Cancel'))))));
    }
  }]);

  return SectionForm;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    activeTab: state.user.activeTab,
    graphGroupSchool: state.sections.graphGroupSchool,
    currentUser: state.user.currentUser,
    schoolData: state.School.schoolDataForSection
  };
};

export default withRouter(connect(mapStateToProps, {
  searchSectionByTitle: searchSectionByTitle,
  addError: addError,
  getSchoolByGroupGraphId: getSchoolByGroupGraphId,
  getEducationGroups: getEducationGroups,
  getSchoolDataForSections: getSchoolDataForSections
})(SectionForm));